import React from "react";
//import 'bootstrap/dist/css/bootstrap.min.css';
import g from "glamorous";
import { css } from "glamor";
import Link from "gatsby-link";
import MySettings from "../utils/mysettings"
import { withPrefix } from "gatsby-link";
import { rhythm } from "../utils/typography";
import Img from "gatsby-image";

import Flash from "../templates/flash";
import Preview from "../templates/preview-link";
import {Helmet} from "react-helmet";
import './index.css'

//import logo from "../img/logo.png";
import logoSvg from "../img/logo.svg";
import ico from "../img/ico16.png";
import brazilNexus from "../img/brazil_nexus.jpg";
import facebookAd from "../img/3p_facebookQ.jpg";//"../img/3p_facebook.jpg";

const linkStyle = css({ float: `right` });

let myAttr = {'page_id': '457049377675752'}

const contacts = [
    {name:"Vadim Pecherskiy", email:"pecher_v%20[at]%20mail.ru"},
    {name:"Alena Zyateva", email:"alenka_sunny%20[at]%20list.ru"},
    //{name:"Andrey Kazanskiy", email:"cypresshll%20[at]%20mail.ru"},
];

//const InnerHTML = require('dangerously-set-inner-html')
//const html = `
//  <script>
//     (adsbygoogle = window.adsbygoogle || []).push({
//          google_ad_client: "ca-pub-2016028305768327",
//          enable_page_level_ads: true
//     });
//</script>
//`

//import ads from "../layouts/google-ads.js";

export default ({ children, data }) =>
  <g.Div
    margin={`0 auto`}
    maxWidth={1600}
    padding={rhythm(2)}
    paddingTop={rhythm(1.5)}
    className="alignCenter"
  >
    <Helmet>
        <title>{data.site.siteMetadata.title}</title>
        <link rel="shortcut icon" href={ico}/>
        {/*ads*/}
        {/*<script async={''} src={withPrefix('/googleAnalyticsUnchanged.js')}></script>*/}
        <script  async={''} src={withPrefix('/fbChat.js')}></script>
    </Helmet>
    <div>
        {/*<Flash src="http://flashteam.ru/head.swf" w="550" h="185"/>*/}
    </div>
    <div className="logoDiv">
        <Link to={`/`}>
          <g.Img src={logoSvg} style={{marginBottom:0, width:"100%", maxWidth:"600px"}} alt={data.site.siteMetadata.title}/>
              {/*<Img sizes={data.logoImg.childImageSharp.sizes} style={{marginBottom:0}} alt={data.site.siteMetadata.title}/>*/}
        </Link>
    </div>
    {children()}
    
    <br/>

    {/*<Preview img={brazilNexus} w="484"
        to="https://play.google.com/store/apps/details?id=air.ru.flashteam.A3Pandas.Brazil.kids_puzzle_game" 
        alt="3 Pandas Brazil mobile" title="3 Pandas on Android -" target="_blank" text="in Google Play"
    />
    <br/>*/}
            
    <Preview img={facebookAd} w="450"
        to="http://www.facebook.com/3PandasGame" 
        alt="3 Pandas facebook" title="3 Pandas - visit fan page" target="_blank" text=""
    />
    
    
{/*Contact:   <a href="mailto:pecher_v [at] mail.ru">Vadim Pecherskiy</a>*/}
     <div>
        <span style={{paddingRight:"10px"}}>Contact:</span>    
        {contacts.map((contact,i) => 
            <span key={i}>
                <a href={"mailto:"+contact.email}>
                    {contact.name}
                </a>
                {i == contacts.length - 1 ? "" : " | "}
            </span>
            )
        }
     </div>
{/*<script async={''} src={withPrefix('/fbChat.js')}></script>*/}
     <div
        className="fb-customerchat"
        data-page_id="457049377675752" /* data- wasn't there, just for react */
        data-ref="chat"
        data-theme_color="#222222"
        data-minimized="false">
     </div>
     <div style={{marginTop:"20px"}}>
         <img src="https://www.easycounter.com/counter.php?sunlight16" alt=""/>
     </div>
  </g.Div>

export const query = graphql`
  query LayoutQuery {
    site {
      siteMetadata {
        title
      }
    }
    logoImg: file(relativePath: { eq: "img/logo.png" }) {
      childImageSharp {
        #comment
        #resolutions(width:427) {
        sizes(maxWidth:427) {
          #...GatsbyImageSharpResolutions_tracedSVG
          ...GatsbyImageSharpSizes_tracedSVG
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/layouts/index.js